<template>
  <div class="user-authenticate_uae">

    <page-header>
      <nav-inner
        :links="[
          { url: '/user/authenticate', text: 'Войти' },
          { url: '/user/register', text: 'Регистрация' },
        ]"/>
    </page-header>

    <div class="page-container_pcr" @keyup.enter="submit">

      <app-inputs ref="inputs">

        <!--<div class="block-wrap block-wrap_error" v-if="authError">
          <div class="block-wrap-error">{{ authError[0] }}</div>
        </div>-->

        <!--<div class="block-wrap" @click="$store.commit('user/setAuthError', '')">-->
        <div class="block-wrap">

          <app-input
            widget="AppMailSimple"
            :options="{ name: 'mail', title: 'E-mail', required: true }"/>

          <app-input
            widget="AppPassword"
            :options="{ name: 'password', title: 'Пароль', required: true }"/>

          <div class="buttons-wrap">
            <button class="vivid-button" @click="submit">Войти</button>
            <span class="recover-pass-lnk" @click="$router.push('/user/recover-pass')">
              Забыли пароль?</span>
          </div>

        </div>

      </app-inputs>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';

export default {

  components: { PageHeader, PageFooter, NavInner, AppInputs, AppInput },

  data() {
    return {
      form: {
        mail: [],
        password: [],
      },
    };
  },

  created() {
    if (this.isAuthenticated) {
      this.redirectAuthenticatedUser();
    }
  },

  computed: {

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    authError() {
      return this.$store.getters['user/getAuthError'];
    },

  },

  watch: {

    isAuthenticated() {
      if (this.isAuthenticated) {
        this.redirectAuthenticatedUser();
      }
    },

    authError(newVal) {
      this.$message.error(newVal[0]);
    },

  },

  methods: {

    submit() {
      if (!window.AppMailAuthJustSelected && !this.$refs.inputs.hasErrors()) {
        const values = this.$refs.inputs.getValues();
        const credentials = { mail: values.mail, password: values.password.password };
        this.$store.dispatch('user/authenticate', credentials);
      }
      window.AppMailAuthJustSelected = false;
    },

    redirectAuthenticatedUser() {
      this.$router.replace({ path: '/' });
    },

  },

};
</script>

<style lang="scss">
.user-authenticate_uae {
  .block-wrap {
    max-width: 700px;
  }
  .buttons-wrap {
    margin: 20px 0 10px;
  }
  .buttons-wrap {
    position: relative;
    @media (max-width: 520px) {
      text-align: left;
    }
  }
  .recover-pass-lnk {
    position: absolute;
    display: block;
    bottom: 7px;
    right: 3px;
    cursor: pointer;
    opacity: 0.6;
    font-weight: 300;
    transition: opacity .3s;
    color: #fff;
    &:hover {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserAuthenticate.vue